import * as React from 'react';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowDownIcon} from '../icon/svg/arrow-down-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowUpIcon} from '../icon/svg/arrow-up-icon';
import {Body} from '../typography/body';

import styles from './change-row.module.css';

type Props = {
    percentChange: string;
    timespanSuffix: string;
    changeType: 'INCREASE' | 'DECREASE' | 'CONSTANT';
};

export function ChangeRow(props: Props) {
    if (props.changeType === 'CONSTANT') {
        return (
            <Body size='small' color='light'>
                No change {props.timespanSuffix}
            </Body>
        );
    }

    let iconColor;
    let bodyColor;
    let Icon;
    switch (props.changeType) {
        case 'INCREASE':
            iconColor = colors.success;
            Icon = ArrowUpIcon;
            bodyColor = 'green';
            break;
        case 'DECREASE':
            iconColor = colors.red;
            Icon = ArrowDownIcon;
            bodyColor = 'error';
            break;
    }

    const change = `${props.percentChange} ${props.timespanSuffix}`;

    return (
        <div className={styles.container}>
            {Icon && <Icon color={iconColor} size={13} alignCenter={true} />}
            {/* @ts-expect-error */}
            <Body size='small' color={bodyColor}>
                {change}
            </Body>
        </div>
    );
}
